import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';

const FilterPaper = ({ title = "Filtry", children, sx, ...props }) => {
    return (
        <Paper variant="outlined" sx={ { p: 3, backgroundColor: 'slate.50', mb: 2, ...sx } } { ...props }>
            <Box sx={ { display: 'flex', alignItems: 'center', mb: 3, gap: 1 } }>
                <FilterListIcon color="primary" fontSize="small"/>
                <Typography variant="overline" color="text.secondary"
                            sx={ { fontSize: '0.85rem', fontWeight: 600, lineHeight: 1 } }>
                    { title }
                </Typography>
            </Box>

            { children }
        </Paper>
    );
};

export default FilterPaper;